import { twMerge } from "@stereoagency/tailwind-config";
import React from "react";
import { useAccentColors } from "../../hooks";
import { Body, Heading } from "../../atoms";
export default function ProfileSummary(param) {
    var label = param.label, name = param.name, subtitle = param.subtitle, _param_accentColor = param.accentColor, accentColor = _param_accentColor === void 0 ? "--colors-purple-700" : _param_accentColor, className = param.className;
    var accentStyle = useAccentColors([
        "colors-profile-summary-accent",
        accentColor
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid gap-3 grid-cols-1 grid-flow-row auto-rows-max", className),
        style: accentStyle
    }, !!label && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", {
        className: "font-heading text-body-small font-semibold uppercase text-[var(--colors-profile-summary-accent)]"
    }, label)), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, name), !!subtitle && /*#__PURE__*/ React.createElement("div", {
        className: "prose"
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "sm"
    }, subtitle))));
}

//# sourceMappingURL=ProfileSummary.js.map